import { useLocationStore } from '../state/storeLocation';

export const useGetMetaPrayerSettings = () => {
	const updateMonth = useLocationStore( ( state ) => state.updateMonth );
	const mncm_selected = useLocationStore( ( state ) => state.mncm_selected );
	const oaac_selected = useLocationStore( ( state ) => state.oaac_selected );
	const hlm_selected = useLocationStore( ( state ) => state.hlm_selected );
	const mfc_selected = useLocationStore( ( state ) => state.mfc_selected );
	const cl_selected = useLocationStore( ( state ) => state.cl_selected );
	const GetMetaPrayerSettings = ( meta ) => {
		if ( meta[ 'meta-key' ] === 'month' ) {
			updateMonth( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'mncm_selected' ) {
			mncm_selected( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'oaac_selected' ) {
			oaac_selected( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'hlm_selected' ) {
			hlm_selected( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'mfc_selected' ) {
			mfc_selected( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'location' ) {
			// this is for updating the custom location when you refresh the PrayerSetting page
			cl_selected( JSON.parse( meta.value.toString() ) );
		}
	};
	return { GetMetaPrayerSettings };
};
